import { RootInitialState } from 'core/common/store/rootReducer';

export const getAuthorizationToken = (state: RootInitialState) => state.auth.token;

export const getAuthLoadingStatus = (state: RootInitialState) => state.auth.loadingStatus;
